import React, { useState } from 'react';

import { ReactComponent as SlideIcon } from '@assets/icons/order/slide-icon.svg';

const ScrollButtons = ({ className, scrollButtonRef }) => {
	const [arrowDisable, setArrowDisable] = useState(true);

	const handleHorizontalScroll = (element, speed, distance, step) => {
		let scrollAmount = 0;
		const slideTimer = setInterval(() => {
			element.scrollLeft += step;
			scrollAmount += Math.abs(step);
			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}
			if (element.scrollLeft === 0) {
				setArrowDisable(true);
			} else {
				setArrowDisable(false);
			}
		}, speed);
	};

	return (
		<div className={className ? className : 'scroll-table-buttons'}>
			<button
				className="left"
				onClick={() => {
					handleHorizontalScroll(scrollButtonRef.current, 10, 70, -220);
				}}
				disabled={arrowDisable}
			>
				<SlideIcon />
			</button>
			&nbsp;&nbsp;{' '}
			<button
				className="right"
				onClick={() => {
					handleHorizontalScroll(scrollButtonRef.current, 10, 70, 220);
				}}
			>
				<SlideIcon />
			</button>
		</div>
	);
};

export default ScrollButtons;
